import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { wcheckBpmnAPI } from './services/api'

export const useBpmnDicts = defineStore('bpmnDicts', () => {
  const raw = ref({
    trigger_events: [],
    doc_types:      [],
    assign_types:   [],
    task_types:     [],
    auto_actions:   [],
  })
  const loaded = ref(false)
  const loading = ref(false)

  async function load() {
    if (loaded.value || loading.value) return
    await _fetch()
  }

  async function reload() {
    loaded.value = false
    await _fetch()
  }

  async function _fetch() {
    loading.value = true
    try {
      const res = await wcheckBpmnAPI.getDicts()
      if (res?.data) {
        Object.assign(raw.value, res.data)
        loaded.value = true
      }
    } finally {
      loading.value = false
    }
  }

  // Форматированные массивы для select-ов: { value, label, description }
  const triggerEvents = computed(() =>
    raw.value.trigger_events.map((r) => ({ value: r.code, label: r.name, description: r.description }))
  )
  const docTypes = computed(() =>
    raw.value.doc_types.map((r) => ({ value: r.code, label: r.name }))
  )
  const assignTypes = computed(() =>
    raw.value.assign_types.map((r) => ({ value: r.code, label: r.name, description: r.description }))
  )
  const taskTypes = computed(() =>
    raw.value.task_types.map((r) => ({ value: r.code, label: r.name, _id: r.id }))
  )
  const autoActions = computed(() =>
    raw.value.auto_actions.map((r) => ({ value: r.code, label: r.name, description: r.description, _id: r.id }))
  )

  function labelOf(list, code) {
    return list.value.find((i) => i.value === code)?.label || code || '—'
  }

  function getRoleLabel(code)   { return labelOf(assignTypes, code) }
  function getTaskLabel(code)   { return labelOf(taskTypes, code) }
  function getEventLabel(code)  { return labelOf(triggerEvents, code) }
  function getDocLabel(code)    { return labelOf(docTypes, code) }
  function getActionLabel(code) { return labelOf(autoActions, code) }

  return {
    loaded, loading, load, reload,
    triggerEvents, docTypes, assignTypes, taskTypes, autoActions,
    getRoleLabel, getTaskLabel, getEventLabel, getDocLabel, getActionLabel,
  }
})
